// extracted by mini-css-extract-plugin
export default {"cls1":"UTFd7Lwd3yhssoyEl440","cls2":"SCJtOX58yYWfbtxorVHb UTFd7Lwd3yhssoyEl440"};